import { render, staticRenderFns } from "./picshow.vue?vue&type=template&id=0e82f96e&scoped=true&"
import script from "./picshow.vue?vue&type=script&lang=js&"
export * from "./picshow.vue?vue&type=script&lang=js&"
import style0 from "./picshow.vue?vue&type=style&index=0&id=0e82f96e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82f96e",
  null
  
)

export default component.exports